<template>
  <div>
    <!-- 搜索框 -->
    <home-header
      :itemIsShow="true"
      @tabItemClick="tabItemClick"
      @searchClick="searchClick"
    />
    <!-- 轮播图 -->
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#D33A46">
      <van-swipe-item
        v-for="item in bannars"
        :key="item.url"
        @click="swipeClick(item)"
      >
        <van-image class="van-swipe-item" :src="item.src" fit="contain" />
      </van-swipe-item>
    </van-swipe>
    <!-- 帖子列表 -->
    <div
      class="container-water-fall"
      :class="{ dialog: clauseShow }"
      ref="scroll"
    >
      <van-pull-refresh v-model="isPullLoading" @refresh="pullRefresh">
        <waterfall
          :col="2"
          :width="itemWidth"
          :gutterWidth="gutterWidth"
          :data="pics"
          @loadmore="loadmore"
          @scroll="scroll"
        >
          <template>
            <div
              class="cell-item"
              v-for="(item, index) in pics"
              :key="item.id"
              @click="postClick(item.id, index)"
            >
              <div class="goods-image-bg">
                <img
                  v-if="showCoverImg(item.media_list)"
                  class="goods-image"
                  alt="加载错误"
                  v-lazy="coverImg(item.media_list)"
                />
                <div v-else class="goods-image-text van-multi-ellipsis--l3">
                  {{ item.content }}
                </div>
                <van-image
                  v-if="isVideo(item.media_list)"
                  class="post-play-icon"
                  :src="require('../../assets/img/play-circle-line.png')"
                  fit="cover"
                />
              </div>

              <div class="van-multi-ellipsis--l2 goods-titile">
                {{ item.title }}
              </div>
              <div v-if="item.user" class="user-info">
                <van-image
                  class="user-info-header"
                  :src="item.user.headimgurl"
                  fit="cover"
                  round
                />
                <span>{{ item.user.nickname }}</span>
              </div>
              <div class="comment">
                <span>{{ "评论 : " + item.reply_count }}</span>
                <i>{{ "点赞 : " + item.like_count }}</i>
              </div>
            </div>
          </template>
        </waterfall>
      </van-pull-refresh>
    </div>
    <!-- 平台规则 -->
    <van-overlay
      class="clause"
      :show="clauseShow"
      @click="clauseClick"
      :lock-scroll="false"
    >
      <div class="clause-wrapper">
        <div class="clause-title" @click.stop>平台规则</div>
        <div class="clause-wrapper-list" @click.stop @scroll="scrollEvent">
          <p class="clause-hint">
            请认真阅读并滑动文字至底部，即可点击同意本平台规则
          </p>
          <h5>一、投稿规则</h5>
          <p>
            本投稿规则（以下称“本规则”）为用户与北京丘比食品有限公司（以下称“丘比”）之间有关使用「丘比粉丝俱乐部」各项服务的法律协议。请用户确保在使用「丘比粉丝俱乐部」前已仔细阅读本规则并充分理解其内容，承诺接受并遵守本规则。用户向「丘比粉丝俱乐部」投稿，视为用户同意接受并充分理解本规则各项条款。如用户对本规则任何条款存在异议，请立即停止登录及使用。
          </p>
          <h5>二、投稿规则的变更和修改</h5>
          <p>
            丘比有权依据国家政策、技术条件、产品功能等变化需要对本规则进行修改并将修改后的规则予以发布。前述修改内容一经正式发布，丘比将以适当的方式（包括但不限于弹窗、通知、公告等）向用户提示修改的内容，以便用户及时了解本规则的最新版本；如用户不同意本规则的修改，应立即停止登录及使用；如用户在本规则修改后继续投稿，则视为用户已经接受并充分理解本规则的修改。
          </p>
          <h5>三、用户行为</h5>

          <p>
            ①用户同意遵守《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国网络安全法》、《中华人民共和国反不正当竞争法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《信息网络传播权保护条例》、《网络信息内容生态治理规定》以及其他一切相关的法律、法规、规章、条例等具有法律效力的规范。
          </p>

          <p>
            ②「丘比粉丝俱乐部」部分功能需要用户登录使用，用户授权登录「丘比粉丝俱乐部」时应确保已同意丘比获取其必需的用户信息（包括但不限于微信头像、昵称、地区和性别等）。用户应确保登录信息的真实性、正确性及完整性，并确保个人帐号及密码的安全性与保密性，对注册帐号名义所从事的一切活动承担全部法律责任。
          </p>
          <p>
            ③「「丘比粉丝俱乐部」中禁止发布任何反对宪法所确定的基本原则、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、破坏民族团结、损害国家荣誉和利益、煽动民族仇恨、民族歧视、破坏民族团结、破坏国家宗教政策、宣扬邪教和封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪、威胁、欺诈、猥亵、骚扰、侮辱或者诽谤他人，侵害他人隐私、名誉等合法权益等法律、行政法规禁止的，虚假、粗俗、歧视、不文明、违反公序良俗或其他另人反感的任何内容。
          </p>
          <p>
            ④「丘比粉丝俱乐部」中禁止发布关于企业特定产品、服务的诽谤和诋毁等投稿内容。
          </p>
          <p>
            ⑤「丘比粉丝俱乐部」中如果存在对于其他企业产品的宣传、诱导、广告等不符合俱乐部活动宗旨的投稿，丘比有权在不通知用户的情况下直接删除。
          </p>
          <p>
            ⑥「丘比粉丝俱乐部」是一个可以让用户和丘比，以及用户和用户间愉快交流对话的平台。主要围绕丘比展开关于每日的饮食和料理等话题。其他网站的话题，或者与丘比无关的话题，因违背「丘比粉丝俱乐部」的开设宗旨，请各位用户尽量避免。
            如果有违背「丘比粉丝俱乐部」宗旨的投稿，或者运营管理方判断为不符合规定的投稿时，丘比有权在不通知用户的情况下直接删除。
          </p>
          <p>⑦请避免任何引起其他用户反感的内容。</p>
          <p>
            ⑧无内容（内容为空）的投稿，将视为重复投稿，丘比有权在不通知用户的情况下直接删除。
          </p>
          <p>
            ⑨重复投稿如果被判断为同一投稿内容，将只保留一篇投稿，其他重复内容予以删除处理。
          </p>
          <p>
            ⑩因用户违反法律或违反本规则导致的一切不利后果由用户自行承担，如因此给丘比及其关联方造成不利后果及损失的，用户应负责消除影响并赔偿因此导致的一切损失。
          </p>
          <p>
            ⑪用户在使用「丘比粉丝俱乐部」时，确保知晓并充分理解「丘比粉丝俱乐部」为信息交流平台，其所获得的内容、信息等可能来源于其他用户及第三方。针对这些信息丘比不保证其正确性、安全性及可靠性，用户需自行判断并自行负担使用该服务的风险。
          </p>
          <h5>四、知识产权</h5>
          <p>
            ①用户充分理解并有责任保证投稿文章中涉及到的内容、图片等均为原创或已获合法授权，不存在任何侵犯他人的著作权、肖像权等权利及合法权益的情形。如因侵犯他人权利或合法权益而引发的纠纷须由用户自行承担全部责任。
          </p>
          <p>
            ②如因投稿内容，图片侵犯他人权利而引发的纠纷须由用户自行承担全部责任并予以解决，丘比及其关联方对上述纠纷不承担任何责任。
          </p>
          <p>
            ③如果存在侵犯第三方著作权、肖像权或者其他权利及合法权益的投稿或者图片时，丘比有权直接删除投稿内容。如存在相对应的活动积分时，将同时取消所给予的积分奖励。
          </p>
          <p>
            ④用户在「丘比粉丝俱乐部」上传、发布的内容（包括但不限于图片、评论、文章、音频、视频等）同意授予丘比及其关联方在全球范围内的、无偿的、永久的、不可撤销的、可转授权的排他性许可（包括但不限于复制权、信息网络传播权、改编权、汇编权、修改权、翻译权、制作衍生品、表演和展示的权利等）。
          </p>
          <p>
            ⑤有关「丘比粉丝俱乐部」中登载的内容，仅限于用户在「丘比粉丝俱乐部」中进行包括但不限于合理引用、经授权的复制或改编等的合理二次利用（以下称“二次利用”），以及丘比及其关联方对素材进行二次利用。禁止其他用户在未得到丘比正式书面授权的情况下，对中登载的内容进行任何形式的二次利用。
          </p>
          <h5>五、活动相关规定</h5>
          <p>
            ①当用户投稿内容违背「丘比粉丝俱乐部」宗旨时，将不给与用户相应的积分奖励，或不能参与相应抽奖等处理。同时，丘比有权在不通知用户的情况下直接删除文章。
          </p>
          <p>
            ②用户报名参与活动时提交的应征内容无论是否违背活动宗旨，如果管理人员判断为不符合活动规则，无论是否进行了当选通知，都视为取消活动资格，敬请谅解。
          </p>
          <p>
            ③如果在活动当选通知联络的同时，被确认为该用户已经退出「丘比粉丝俱乐部」，则该用户将被从该活动的当选名单中删除。
          </p>
          <p>④「丘比粉丝俱乐部」活动的当选名额不可转让，也不可进行现金兑换。</p>
          <p>⑤参加活动时涉及到的网络通信费，电话费等均由参加者自行负担。</p>
          <p>⑥活动奖品的派发地只限于中国内地地区，不包括港澳台地区。</p>
          <p>
            ⑦活动奖品的送达时间以实际物流情况为准，有可能存在延迟的情况，敬请谅解。
          </p>
          <h5>积分、会员等级规则：</h5>
          <p>积分获取方法一览：</p>
          <img
            style="width: 100%"
            src="../../assets/img/home-instructions-score.jpg"
            alt=""
          />
          <p>会员等级一览：</p>
          <img
            style="width: 100%"
            src="../../assets/img/home-instructions-vip.png"
            alt=""
          />
          <h5>免责说明</h5>
          <p>※该积分只能应用与本平台的积分系统中。不可兑换现金。</p>
          <p>※该积分不可进行转让，也不可与其他会员的积分合并使用。</p>
          <p>※积分规则，会员等级，成就勋章等今后有可能发生变动，敬请谅解。</p>
          <h5>本规则生效日期：2025年04月14日</h5>
          <h5>个人信息处理</h5>
          <p>尊敬的访问者：</p>
          <p>衷心欢迎您访问丘比粉丝俱乐部。</p>
          <p>
            根据《中华人民共和国个人信息保护法》等相关法律法规（以下称“个人信息保护法规”）的规定，我们作为个人信息的处理者，在处理您的个人信息前，将依法履行个人信息保护法规规定的各项公示和告知义务并取得您对相关事项的同意。为了维护您作为个人信息提供者的合法权益，请您详细阅读以下内容。
          </p>
          <p style="font-weight: 700">
            当您按下下面的“同意”按钮时，即表示您已经完成了以下工作并作出了相关的同意我们处理您的个人信息的意思表示。
          </p>
          <p>
            （1）您已经详细阅读并理解了我们向您公示的<span
              style="color: red; text-decoration: underline"
              @click="privacyPolicyClick"
              >《隐私保护政策》</span
            >的全部内容。<span
              style="color: red; text-decoration: underline"
              @click="privacyPolicyClick"
              >《隐私保护政策》</span
            >您可以通过点击本公众号内的“爱在餐桌”-“隐私保护”获得。
          </p>
          <p>
            （2）当您访问丘比食品公众号内的丘比粉丝俱乐部（Fun
            Club）时，表示您同意自愿向我们提供该以下信息（以下称“初步个人信息”）并同意我们将该信息用于下述第（3）项的处理目的：
          </p>
          <p>
            1）<span style="font-weight: 700">您的微信头像</span
            >（当您的头像不符合认定为个人信息的法定要件时，将不被作为个人信息处理）
          </p>
          <p>
            2）<span style="font-weight: 700">您的微信用户名</span
            >（当您的微信用户名不符合认定为个人信息的法定要件时，将不被作为个人信息处理）
          </p>
          <p>
            上述初步个人信息是您加入丘比粉丝俱乐部并享受粉丝权益所需的“最低必要信息”。
            您仍有权拒绝提供或撤回您已经提供的上述信息，或有关对于我们处理您个人信息的同意，，但此时您将无法访问丘比粉丝俱乐部（Fun
            Club），对此请您理解。
          </p>
          <p>（3）您同意我们将您的初步个人信息用于以下目的：</p>
          <p style="font-weight: 700">
            用于实施我们对于访问丘比粉丝俱乐部人群的分析、统计和管理，以提升服务质量进而提升客户满意度
          </p>
          <p>（4）委托处理附加个人信息的受托人</p>
          <p>
            由于本公众号由我公司（北京丘比食品有限公司）委托<span
              style="font-weight: 700"
              >北京易启商贸有限公司</span
            >（以下称“受托人”）制作并维护。因此，您在本公众号中所提供的的信息，将由我公司委托受托人进行信息处理、保存和管理。您同意由受托人处理您的信息。
            受托人的详细信息如下：
          </p>
          <p style="font-weight: 700">
            公司名称：北京易启商贸有限公司
          </p>
          <p style="font-weight: 700">联系方式：13911060020</p>
          <p style="font-weight: 700">
            处理目的：辅助我公司实现本规则第二条中的“所收集的个人信息的使用目的”
          </p>
          <p style="font-weight: 700">
            处理方式：对于个人信息进行收集、存储，应北京丘比食品有限公司的要求向其进行提供
          </p>
          <p style="font-weight: 700">个人信息的种类：您所提供的信息</p>
        </div>
        <van-button
          class="clause-agree"
          type="danger"
          size="normal"
          :disabled="agreeAbled"
          block
          @click.stop="agreeClick"
          >同意</van-button
        >
      </div>
    </van-overlay>
    <van-overlay class="ad" :show="adShow">
      <div class="adver-wrapper">
        <van-image
          class="adver-title-img"
          :src="require('../../assets/img/ad-title-img.png')"
        ></van-image>
        <div class="adver-banner-wrap">
          <van-image
            v-for="item in adves"
            :key="item.url"
            class="adver-banner"
            :src="item.src"
            fit="cover"
            @click="adveClick(item)"
          ></van-image>
          <div class="adver-msg">点击上方图片 立即查看</div>
          <!-- <div class="adver-msg">点击上方图片 立即报名参加</div> -->
          <!-- <div class="adver-msg">丘比面包酱新上市 点击查看</div> -->
        </div>
        <van-image
          class="adver-close"
          :src="require('../../assets/img/adclose.png')"
          fit="fill"
          @click="adShow = false"
        ></van-image>
      </div>
    </van-overlay>
    <!-- 广告弹出层 -->
    <!-- <van-overlay class="ad" :show="adShow">
      <view
        class="adver-wrapper"
        :src="require('../../assets/img/adbg3.png')"
        @click.stop
      >
        <van-image
          class="adver-close"
          :src="require('../../assets/img/adclose.png')"
          fit="fill"
          @click="adShow = false"
        ></van-image>
        <div class="adver-banner-wrap">
          <van-image
            v-for="item in adves"
            :key="item.url"
            class="adver-banner"
            :src="item.src"
            fit="cover"
            @click="adveClick(item)"
          ></van-image>
        </div>
      </view>
    </van-overlay> -->
  </div>
</template>

<script>
import HomeHeader from "./child/HomeHeader";
import {
  getPics,
  getFollowingTopics,
  getActivityTopics,
  agreeTosRead,
} from "network/home";
import { getUserInfo } from "network/profile";
export default {
  components: {
    HomeHeader,
  },
  data() {
    return {
      offset: 0,
      page: 1,
      pics: [],
      bannars: [
        { src: require("../../assets/img/banner16.jpg"), url: "https://mp.weixin.qq.com/s/y4DakjTe2dwE1mtDAXMC7A" },
        { src: require("../../assets/img/banner15.jpg"), url: "not" },
        { src: require("../../assets/img/banner1.jpg"), url: "10091" },
        { src: require("../../assets/img/banner14.jpg"), url: "37585" },
        // { src: require("../../assets/img/banner13.jpg"), url: "not" },
        // { src: require("../../assets/img/banner12.jpg"), url: "https://mp.weixin.qq.com/s/pIBwXLvVxQjfKeUBrDdm4w" },
        // { src: require("../../assets/img/banner11.jpg"), url: "34596" },
        // { src: require("../../assets/img/banner7.jpg"), url: "not" },
        // { src: require("../../assets/img/banner8.jpg"), url: "not" },
        // { src: require("../../assets/img/banner6.jpg"), url: "https://mp.weixin.qq.com/s/Vmm3B0YuBMq2G8v6ZgRddA" },
        // { src: require("../../assets/img/banner5.jpg"), url: "https://mp.weixin.qq.com/s/i_z5n93iIJRV0FraolB24g" },
        // { src: require("../../assets/img/banner4.png"), url: "14897" },
        { src: require("../../assets/img/banner2.jpg"), url: "https://xy.instqr.com/qiubih5/#/" },
        { src: require("../../assets/img/banner3.jpg"), url: "not" },
      ],
      adves: [{ src: require("../../assets/img/banner16.jpg"), url: "https://mp.weixin.qq.com/s/y4DakjTe2dwE1mtDAXMC7A" }],
      currentIndex: 1, //当前选中的[最新， 关注， 活动， 积分商城],默认最新
      agreeAbled: true,
      clauseShow: false, //平台协议
      adShow: true, //广告显示
      isPullLoading: false, //下拉刷新
    };
  },
  computed: {
    itemWidth() {
      return 175 * (document.body.clientWidth / 375);
    },
    gutterWidth() {
      return 5 * (document.documentElement.clientWidth / 375);
    },
    coverImg() {
      return (imgs) => {
        let pics = imgs.filter(
          (item) => item.type == "image" || item.type == "video"
        );
        return pics.length > 0
          ? pics[0].url
          : require("../../assets/img/loading.gif");
      };
    },
    showCoverImg() {
      return (imgs) => {
        let pics = imgs.filter(
          (item) => item.type == "image" || item.type == "video"
        );
        return pics.length > 0;
      };
    },
    isVideo() {
      return (imgs) => {
        let pics = imgs.filter((item) => item.type == "video");
        return pics.length > 0 ? true : false;
      };
    },
  },
  created() {
    this.getPics(this.page);
    document.body.classList.add("dialog");
    //来源
    //先清空
    localStorage.removeItem("from");
    const from = this.$route.query.from;
    if (from) {
      localStorage.setItem("from", from);
    }
    //获取个人信息
    getUserInfo(from, this.$route.query.inviter_id).then((res) => {
      this.userInfo = res.data;
      localStorage.setItem("userInfo", JSON.stringify(res.data));
      this.clauseShow = res.data.tos_read == "0";
    });
  },
  activated() {
    document.documentElement.scrollTop = this.offset;
  },
  mounted() {},
  methods: {
    /**
     * 点击分类
     */
    tabItemClick(index) {
      switch (index) {
        case 1:
          if (this.currentIndex !== index) {
            this.currentIndex = index;
            this.page = 1;
            this.pics = [];
            this.getPics(this.page);
          }
          break;
        case 2:
          if (this.currentIndex !== index) {
            this.currentIndex = index;
            this.page = 1;
            this.pics = [];
            this.getFollowingTopics(this.page);
          }
          break;
        case 3:
          if (this.currentIndex !== index) {
            this.currentIndex = index;
            this.page = 1;
            this.pics = [];
            this.getActivityTopics(this.page);
          }
          break;
        case 4:
          // this.$router.push({ path: "/mall" });
          window.location.href = "https://mall.jd.com/index-762585.html";
          break;
      }
    },
    //点击搜索
    searchClick() {
      this.$router.push({ path: "/searchinfo" });
    },
    //点击某个帖子
    postClick(id, index) {
      this.$router.push({
        path: "/homepostdefault",
        query: {
          id,
        },
      });
      // if (index === 0) {
      //   this.$router.push({ path: "/homepost" });
      // } else {
      //   this.$router.push({
      //     path: "/homepostdefault",
      //     query: {
      //       id,
      //     },
      //   });
      // }
    },
    //轮播图
    swipeClick(item) {
      if (item.url.includes("http")) {
        window.location.href = item.url;
      } else if (item.url == "not") {
      } else if (item.url > 0) {
        this.$router.push({
          path: "/homepostdefault",
          query: {
            id: item.url,
          },
        });
      } else {
        this.$router.push({
          path: "/mall",
        });
      }
      // else if (index === 1) {
      //   this.$router.push({
      //     path: "/homepostdefault",
      //     query: {
      //       id: 11814,
      //     },
      //   });
      //   // window.location.href =
      //   //   "https://mp.weixin.qq.com/s/ZryybwAxe4L7--hykgTHMA";
      //  this.$router.replace({
      //     path: "/sign",
      //   });
      //   his.$router.go(0);
      // }
    },
    //广告点击
    adveClick(item) {
      if (item.url.includes("http")) {
        window.location.href = item.url;
      } else if (item.url.includes("/")) {
        // 路由跳转
        this.$router.push({
          path: item.url,
        });
      } else if (item.url > 0) {
        this.$router.push({
          path: "/homepostdefault",
          query: {
            id: item.url,
          },
        });
      } else {
        this.$router.push({
          path: "/mall",
        });
      }
    },
    //点击遮罩层
    clauseClick() {
      this.clauseShow = true;
    },
    agreeClick() {
      agreeTosRead().then((res) => {
        this.clauseShow = false;
      });
    },
    //点击隐私保护政策
    privacyPolicyClick() {
      console.log(111);
      this.$router.push({
        path: "/privacy",
      });
    },
    /**
     * 自定义方法
     */
    //平台协议滚动到底部
    scrollEvent(e) {
      let self = this;
      let Scroll = e.target;
      // 网页可见区域高：document.body.clientHeight
      // 网页正文全文高：document.body.scrollHeight
      let scrollHeight = Scroll.scrollHeight - Scroll.clientHeight;
      self.scrollTop = Scroll.scrollTop;
      if (scrollHeight - Scroll.scrollTop < 100 && !self.loadflag) {
        self.agreeAbled = false;
      }
    },
    scroll(scrollData) {
      if (scrollData.scrollTop > 0) {
        this.offset = scrollData.scrollTop;
      }
    },
    //加载更多
    loadmore() {
      this.page++;
      if (this.currentIndex === 1) {
        this.getPics(this.page);
      } else if (this.currentIndex === 2) {
        this.getFollowingTopics(this.page);
      } else {
        this.getActivityTopics(this.page);
      }
    },
    //下拉刷新
    pullRefresh() {
      this.page = 1;
      if (this.currentIndex === 1) {
        this.getPics(this.page);
      } else if (this.currentIndex === 2) {
        this.getFollowingTopics(this.page);
      } else {
        this.getActivityTopics(this.page);
      }
    },
    /**
     * 网络请求
     */
    //最新帖子列表
    getPics(page) {
      getPics(page).then((res) => {
        if (page === 1) {
          this.pics = [];
        }
        this.pics = this.pics.concat(res.data);
        this.isPullLoading = false;
      });
    },
    //关注帖子列表
    getFollowingTopics(page) {
      getFollowingTopics(page).then((res) => {
        if (page === 1) {
          this.pics = [];
        }
        this.pics = this.pics.concat(res.data);
        this.isPullLoading = false;
      });
    },
    //活动帖子列表
    getActivityTopics(page) {
      getActivityTopics(page).then((res) => {
        if (page === 1) {
          this.pics = [];
        }
        this.pics = this.pics.concat(res.data);
        this.isPullLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.my-swipe {
  margin: 110px 10px 15px 10px;
}
.van-swipe-item {
  height: 150px;
  width: 100%;
  font-size: 20px;
  text-align: center;
}

.container-water-fall {
  padding: 0px 10px 50px 10px;
  width: 100%;
}

.goods-image-bg {
  position: relative;
}
.post-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60px;
  height: 60px;
  margin-top: -30px;
  margin-left: -30px;
}
.goods-image {
  width: 175px;
}
.goods-image-text {
  width: 175px;
  font-size: 13px;
  color: #707070;
}
.goods-titile {
  margin-top: 5px;
  font-weight: 700;
  font-size: 15px;
  line-height: 1.5;
  color: #232323;
}
.user-info {
  margin-top: 10px;
  font-weight: 700;
  color: #707070;
  font-size: 13px;
}
.user-info-header {
  margin-right: 5px;
  width: 30px;
  height: 30px;
  border: 1px solid #858585;
  border-radius: 15px;
  vertical-align: middle;
}
.comment {
  margin: 10px 0px;
  font-size: 14px;
  color: #707070;
}
.comment span {
  margin-right: 15px;
}
.comment i {
  font-style: normal;
  margin-right: 5px;
}
.clause {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.clause-wrapper {
  /* margin: 200px auto; */
  padding: 20px 20px;
  width: 250px;
  height: 320px;
  background-color: #fff;
}
.clause-wrapper-list {
  height: 200px;
  overflow: hidden;
  overflow-y: scroll;
}
.clause-title {
  margin-bottom: 10px;
  color: #232323;
  font-size: 15px;
  font-weight: 700;
  text-align: center;
}
.clause-wrapper-list .clause-hint {
  font-weight: 700;
  font-size: 14px;
  color: var(--color-main);
}
.clause-wrapper h5 {
  margin: 10px 0;
}
.clause-wrapper p {
  font-size: 12px;
  color: #707070;
  text-indent: 1.5em;
}
.dialog {
  overflow: hidden;
  height: 375px;
}
.clause-agree {
  margin: 10px 0;
}
.ad {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  height: 100vh;
}
.adver-wrapper {
  position: relative;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
}
.adver-title-img {
  width: 250px;
  z-index: 10;
}
.adver-close {
  margin-top: 10px;
  width: 40px;
  height: 40px;
}
.adver-banner-wrap {
  margin-top: -25px;
  padding: 20px 10px 10px 10px;
  overflow: hidden;
  width: 100%;
  border-radius: 20px;
  border: 5px solid #f2aa7e;
  background-color: #fbf0ec;
}
.adver-banner {
  margin-top: 10px;
  width: 100%;
}
.adver-msg {
  font-size: 14px;
  text-align: center;
  color: #4a4949;
}
</style>